import { render, staticRenderFns } from "./products.vue?vue&type=template&id=a65c6262&scoped=true"
import script from "./products.vue?vue&type=script&lang=ts"
export * from "./products.vue?vue&type=script&lang=ts"
import style0 from "./products.vue?vue&type=style&index=0&id=a65c6262&prod&lang=css"
import style1 from "./products.vue?vue&type=style&index=1&id=a65c6262&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65c6262",
  null
  
)

export default component.exports